/**
 * @generated SignedSource<<7922b8fc735f5663ae16a535c08157e6>>
 * @relayHash 4cf53c0c4d29cc0095440ee41e82d5a0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f336a9f36da7b06a61ec2d4e10d12597bf7305bd3e5f188d28d12b5605adce29

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBusinessBoardEmbedQuery } from './src_jiraBusinessBoardEmbedQuery.graphql';

import isUsingNewCreate_provider from '@atlassian/jira-relay-provider/src/mbw-67-board-issue-create.relayprovider';
import withMergedWorkflows_provider from '@atlassian/jira-relay-provider/src/merge-board-workflows.relayprovider';
import isBusinessRelayBoardWorkflowEditingEnabled_provider from '@atlassian/jira-relay-provider/src/relay-board-workflow-editing.relayprovider';

const node: PreloadableConcreteRequest<src_jiraBusinessBoardEmbedQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "f336a9f36da7b06a61ec2d4e10d12597bf7305bd3e5f188d28d12b5605adce29",
    "metadata": {},
    "name": "src_jiraBusinessBoardEmbedQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcmbw67boardissuecreaterelayprovider": isUsingNewCreate_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcrelayboardworkfloweditingrelayprovider": isBusinessRelayBoardWorkflowEditingEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcmergeboardworkflowsrelayprovider": withMergedWorkflows_provider
    }
  }
};

export default node;
